<mat-dialog-content>
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>

        <h2>Audit Log Detail</h2>

        <div *ngIf="!isLoading">
            <div *ngIf="!isLoading" class="header-container">
                <table>
                    <tr>
                        <td>TimeStamp</td>
                        <td>{{log.timeStamp | date:'short'}}</td>
                    </tr>
                    <tr>
                        <td>User ID</td>
                        <td>{{log.userID}}</td>
                    </tr>
                    <tr>
                        <td>User Name</td>
                        <td>{{log.firstName}}  {{log.lastName}}</td>
                    </tr>
                    <tr>
                    <tr>
                        <td>Log Message</td>
                        <td>{{log.message}}</td>
                    </tr>
                    <tr *ngIf="log.description">
                        <td>Log Description</td>
                        <td>{{log.description}}</td>
                    </tr>
                </table>
            </div>

            <div *ngIf="log.oldData || log.newData" class="data-container">
                <table>
                    <tr>
                        <th *ngIf="log.oldData" style="text-align: left;">Old Record</th>
                        <th *ngIf="log.newData" style="text-align: left;">New Record</th>
                    </tr>
                    <tr>
                        <td *ngIf="log.oldData">
                            <table>
                                <tr *ngFor="let key of oldDataKeys">
                                    <td>{{key}}</td>
                                    <td>{{log.oldData[key]}}</td>
                                </tr>
                            </table>
                        </td>
                        <td *ngIf="log.newData">
                            <table>
                                <tr *ngFor="let key of newDataKeys">
                                    <td [style]="getChangedFieldStyle(key)">{{key}}</td>
                                    <td [style]="getChangedFieldStyle(key)">{{log.newData[key]}}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="button-container">
            <button mat-raised-button color="accent" mat-dialog-close>Close</button>
        </div>
</mat-dialog-content>